import { Component, OnInit, Input } from '@angular/core';
import {ILegendItem} from '../legend.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';


@Component({
    selector: 'app-legend-item',
    imports: [FlexLayoutModule],
    templateUrl: './legend-item.component.html',
    styleUrl: './legend-item.component.scss'
})
export class LegendItemComponent implements OnInit{
   @Input() item: ILegendItem;

   ngOnInit(): void {   
  }
}
